<template>
	<div style="padding-top: 85px;">
		<headerList></headerList>
		
		<div class="detail-box">
			<!-- 详情版心主要内容 -->
			<div  class="detail-main">
				<div class="ptb-15 flex flex-y- flex-x-s f-14 c-66">
					<span>当前位置: </span>
					<span class="ml-5">主页</span>
					<span class="iconfont iconxiangyoujiantou mlr-5"></span>
					<span>新闻列表</span>
				</div>
				
				<div class="flex flex-y-s">
					<!-- 左侧内容 -->
					<div>
						<ul class="news_list_box bg-ff plr-40 ptb-20">
							<li class="pt-20 pb-15 news_detail b-b" v-for="item,index in new_list" :key="item.docId" @click="bindlinkTo(item.id)">
								<p class="bold f-26 c-00 onelist">{{item.docName}}</p>
								<div class="flex mt-15" style="">
									<img class="mr-20" :src="item.pub_cover" alt="" v-show="item.pub_cover" style="margin: 0 20px 0 0;">
									<div class="flex-box">
										<p class="twolist text f-14 c-88">{{item.XINWENZIXUN_REMARK}}</p>
										<p class=" f-14 c-88 pl-30 mt-5">{{item.date}}</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="bg-ff flex-c pb-30">
							<Page class-name="page-class" :total="total" :page-size="10" />
						</div>
					</div>
					<!-- 右侧内容 -->
					<div class="right_content">
						<!-- 栏目新闻 -->
						<div class="news_like bg-ff">
							<div class="title plr-30 flex flex-x-s b-b"> <span class="f-18 c-29 ml-10">栏目新闻</span></div>
							<ul class="plr-30 over  pb-20">
								<li  @click="bindlinkTo(item.id)"class="news_like_detail mt-15" v-for="item,index in new_like" v-show="index == 0">
									<div class="flex"> 
										<div class="date-box mr-10 f-12 c-ff">{{item.year}}-</div>
										<div class="f-16 c-66 onelist flex-box">{{item.SYS_TOPIC}}</div>
									</div>
									<div class="flex mt-10">
										<img class="mr-10" :src="item.pub_cover" alt="" />
										<div class="flex-box f-14 c-99 twolist">{{item.XINWENZIXUN_REMARK}}</div>
									</div>
								</li>
								<li  @click="bindlinkTo(item.id)" class="news_like_detail mt-15" v-for="item,index in new_like" v-show="index > 0">
									<div class="flex">
										<div class="date-box mr-10 noone f-12 c-ff">{{item.year}}-</div>
										<div class="f-16 c-66 onelist flex-box">{{item.SYS_TOPIC}}</div>
									</div>
								</li>
							</ul>
						</div>
						<!-- 热门图片 -->
						<div class="news_like bg-ff mt-20">
							<div class="title plr-30 flex flex-x-s b-b"> <span class="f-18 c-29 ml-10">热门图片</span></div>
							<ul class=" over">
								<li class="news_like_detail img p-10 b-t flex" v-for="item,index in hot_list" v-show="index < 4" @click="enterDetail(item.docId,item.doclibId)">
									<img :src="item.COVERPATH" alt="" class="mr-10 radius-5" />
									<div class="flex-box">
										<p class="f-16 c-33 onelist">{{item.SYS_TOPIC}}</p>
										<div class="flex flex-x-s f-14 c-99 mt-10">
											<p>{{item.date}}</p>
											<p class="ml-10">浏览量 {{item.CLICK_COUNT?item.CLICK_COUNT:0}}</p>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<footer-view></footer-view>
	</div>
</template>

<script>
import footerView from './footer.vue'
import headerList from './header_nav.vue'
export default {
  data () {
    return {
			new_list: [], // 新闻列表
			new_like: [], // 新闻列表_排行榜
			total:0,
			hot_list:[]
		}
  },
	
	components: {
		headerList,
		footerView
	},

  created () {
		let _this = this
		this.getnewsinfo()
		this.getnewslike()
		this.getimgLike()
	},

  methods: {

		 // 跳转到图片详情
		 toImgdetail (id,tid) {
		 	this.$router.push({path: '/img_detail', query: {id,tid}})
		 },
		 
		 // 获取新闻列表
		 async getnewsinfo (page) {
		 	let _this = this
			_this.$Spin.show()
		 	let data = { 
		 				conditions:JSON.stringify([{pub_col_id:4},{pub_resource_type:"XINWENZIXUN"}]),
						groupBy: "pub_resource_id",
						orderBy: "pub_a_order asc pub_lastmodified desc id asc",
		 				pageNo:1,
		 				pageSize:12,
		 				searchText:"",
		 			}
		 	const res = await _this.post('/spc/cms/publish/list.do', data )
		 	// console.log(res)
		 	if ( res.success) {
				res.result.forEach( x => {
					x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE)
					x.year = x.date.substr(0,4)
					x.mon = x.date.substr(5,2)
					x.day = x.date.substr(8,2)
				})
		 			 _this.new_list = res.result
					 _this.total = res.totalCount
					 _this.$Spin.hide()
		 	} else {
		 			_this.$Message.error(res.description);
		 	}
		 },
		 
		 // 获取新闻列表——拍上榜
		 async getnewslike (page) {
		 	let _this = this
		 	let data = { 
		 				conditions:JSON.stringify([{pub_col_id:4},{pub_resource_type:"XINWENZIXUN"}]),
		 				orderBy: "pub_click_num",
						groupBy: 'pub_resource_id',
		 				pageNo:1,
		 				pageSize:6,
		 				searchText:""
		 			}
					
		 	const res = await _this.post('/spc/cms/publish/list.do', data )
		 	if ( res.success) {
		 				res.result.forEach( x => {
		 					x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE)
		 					x.year = x.date.substr(0,4)
		 				})
		 			 _this.new_like = res.result
		 	} else {
		 			_this.$Message.error(res.description);
		 	}
		 },
		 
		 // 获取图片排行
		 async getimgLike () {
			 let _this = this
			 const res = await _this.get_res('/search?t=25&size=5&page=0&sld=AHSCXB&sort=CLICK_1_0_l,desc')
			 _this.hot_list = res.content
		 },
		 
		 // 跳转
		 bindlinkTo (id) {
		 	this.$router.push({path:'/news_detail',query: {id}})
		 },
		 
		 // 跳转
		 enterDetail (id,tid) {
		 	if (tid == 25 || tid == 837) {
		 				this.$router.push({path:'/img_detail',query: {id,tid}})
		 			} else if (tid == 28) {
		 				this.$router.push({path:'/audio_detail',query: {id,tid}})
		 			} else {
		 				this.$router.push({path:'/video_detail',query: {id,tid}})
		 			}
		 },
		 
	},
	
	// 监听器监听路由的变化
	watch: {
		'$route'(to,from) {
			// let _this = this
			// _this.cats = _this.$route.query.cats
			// _this.name = _this.$route.query.name
			// 做一些路由变化的响应
			// this.bindvideoList(0)
		}
	},
	

}
</script>

<style lang="less" scoped>
	
	.detail-box {
		background-color: #f1f2f6;
		padding-bottom: 120px;
		
	}
	.detail-main {
		width: 1200px;
		margin: 0 auto;
	}
	.iconxiangyoujiantou {
		font-size: 12px;
		color: #666;
	}
	
	// 新闻列表
	.news_list_box {
		width: 800px;
		margin-bottom: 0!important;
		.news_detail {
			// height: 150px;
			cursor: pointer;
		}
		img {
			width: 150px;
			height: auto;
		}
		.text {
			text-indent: 2em;
			line-height: 1.8;
		}
	}
	
	// 右侧内容
	.right_content {
		width: 380px;
	}
	.news_like {
		.title {
			height: 48px;
		}
		.title::before {
			content: '';
			height: 16px;
			width: 2px;
			background-color: #0e0963;
		}
	}
	.news_like_detail {
		cursor: pointer;
		.date-box {width: 40px;height: 20px;background-color: #0e0963;text-align: center;line-height: 20px;}
		img {width: 105px;height: auto;}
		.date-box.noone {background-color: #b2b3ad;}
	}
	.news_like_detail.img {
		cursor: pointer;
		img {width: 110px;height: auto;}
	}
	
</style>
